/**
 * Phase 16.R9: editable promote platforms in Gallery caption generation view.
 * Saves to the media asset so promote inherits the selection.
 */
import React, { memo, useEffect, useState } from 'react';
import {
  Checkbox,
  FormControl,
  FormHelperText,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
  Stack,
  Typography,
} from '@mui/material';

function GalleryTargetPlatformsField({
  assetId,
  options = [],
  initialValue = [],
  defaultValue = ['facebook'],
  saving = false,
  onSave,
}) {
  const [value, setValue] = useState(() =>
    Array.isArray(initialValue) && initialValue.length
      ? initialValue
      : defaultValue,
  );

  useEffect(() => {
    const next =
      Array.isArray(initialValue) && initialValue.length
        ? initialValue
        : defaultValue;
    setValue(next);
  }, [assetId, initialValue, defaultValue]);

  const labelFor = (v) => options.find((o) => o.value === v)?.label || v;

  return (
    <Stack spacing={1} sx={{ mb: 2 }}>
      <Typography variant="subtitle2" sx={{ color: '#8b949e' }}>
        Target platforms
      </Typography>
      <Typography variant="caption" sx={{ color: '#6e7681' }}>
        Choose networks before promote. Saved on this asset and used when you
        create draft posts (same set as the Gallery toolbar).
      </Typography>
      <FormControl fullWidth size="small" disabled={saving}>
        <InputLabel id={`gallery-asset-platforms-${assetId}`} sx={{ color: '#8b949e' }}>
          Platforms
        </InputLabel>
        <Select
          labelId={`gallery-asset-platforms-${assetId}`}
          label="Platforms"
          multiple
          value={value}
          onChange={async (e) => {
            const next = e.target.value;
            const arr = typeof next === 'string' ? next.split(',') : next;
            const allowed = arr.filter((p) =>
              options.some((o) => o.value === p),
            );
            const cleaned = allowed.length ? allowed : defaultValue;
            setValue(cleaned);
            await onSave?.(cleaned);
          }}
          renderValue={(selected) =>
            (selected || []).map(labelFor).join(', ')
          }
          sx={{
            color: '#f0f6fc',
            '& .MuiOutlinedInput-notchedOutline': { borderColor: '#30363d' },
          }}
        >
          {options.map((opt) => (
            <MenuItem key={opt.value} value={opt.value}>
              <Checkbox
                size="small"
                checked={value.includes(opt.value)}
                sx={{ color: '#8b949e', py: 0 }}
              />
              <ListItemText primary={opt.label} />
            </MenuItem>
          ))}
        </Select>
        <FormHelperText sx={{ color: '#8b949e', mx: 0, mt: 0.5 }}>
          Instagram via Facebook → Instagram link — enable on Clients
        </FormHelperText>
      </FormControl>
    </Stack>
  );
}

export default memo(GalleryTargetPlatformsField);
